import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  canonicalUrl?: string;
  ogTitle?: string;
  ogDescription?: string;
  ogImage?: string;
  ogType?: string;
  schema?: Record<string, unknown>;
}

export default function SEOHead({
  title,
  description,
  keywords,
  canonicalUrl,
  ogTitle,
  ogDescription,
  ogImage,
  ogType = 'website',
  schema,
}: SEOHeadProps) {
  const location = useLocation();

  const defaultTitle = '神马视频 - 西瓜视频、西瓜视频免费在线观看 | 菠萝视频青青草视频最新电影电视剧高清全集不缓冲';
  const defaultDescription = '神马视频✨提供西瓜视频免费、西瓜视频等知名平台免费观影，菠萝视频、🎭青青草视频最新电影电视剧高清全集不缓冲在线播放，畅享影视。';
  const defaultKeywords = '西瓜视频免费,西瓜视频,菠萝视频,青青草视频,神马视频,免费观看,最新电影,电视剧高清,全集不缓冲,在线观看,影视大全';
  const baseUrl = 'https://www.shenmashipin.com';

  const pageTitle = title || defaultTitle;
  const pageDescription = description || defaultDescription;
  const pageKeywords = keywords || defaultKeywords;
  const pageUrl = canonicalUrl || `${baseUrl}${location.pathname}`;

  useEffect(() => {
    document.title = pageTitle;

    const setMeta = (name: string, content: string, prop = false) => {
      const attr = prop ? 'property' : 'name';
      let el = document.querySelector(`meta[${attr}="${name}"]`);
      if (!el) {
        el = document.createElement('meta');
        el.setAttribute(attr, name);
        document.head.appendChild(el);
      }
      el.setAttribute('content', content);
    };

    setMeta('description', pageDescription);
    setMeta('keywords', pageKeywords);
    setMeta('og:title', ogTitle || pageTitle, true);
    setMeta('og:description', ogDescription || pageDescription, true);
    setMeta('og:url', pageUrl, true);
    setMeta('og:type', ogType, true);
    if (ogImage) setMeta('og:image', ogImage, true);
    setMeta('twitter:title', ogTitle || pageTitle);
    setMeta('twitter:description', ogDescription || pageDescription);
    setMeta('twitter:url', pageUrl);

    let canonical = document.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement('link');
      canonical.setAttribute('rel', 'canonical');
      document.head.appendChild(canonical);
    }
    canonical.setAttribute('href', pageUrl);

    let schemaEl = document.querySelector('script[type="application/ld+json"]');
    if (schemaEl) schemaEl.remove();
    if (schema) {
      const script = document.createElement('script');
      script.type = 'application/ld+json';
      script.textContent = JSON.stringify(schema, null, 2);
      document.head.appendChild(script);
    }
  }, [pageTitle, pageDescription, pageKeywords, pageUrl, ogTitle, ogDescription, ogImage, ogType, schema]);

  return null;
}